import type { Document } from '@contentful/rich-text-types'

const treatYoutubeUrl = (url: string) => {
  if (url.toLowerCase().includes('youtube.com')) {
    const urlObject = new URL(url)
    const videoId = urlObject.pathname.split('/').pop()
    const searchParams = new URLSearchParams(urlObject.search)

    if (!searchParams.has('rel')) {
      searchParams.set('rel', '0')
    }

    return `https://www.youtube.com/embed/${videoId}?${searchParams.toString()}`
  }

  /**
   * Every other host (Vimeo, Wistia, ...) is treated as an opaque embed URL:
   * authors paste the player URL the host gives them and we pass it through
   * untouched. Only YouTube needs rewriting, because its share URLs are not
   * embeddable as-is.
   */
  return url
}

/**
 *
 * TODO: Support display presenters
 * TODO: Support displaying description
 */
export const VideoFigure = ({
  src,
  title,
}: {
  src: string
  title: string
  description?: Document
}) => (
  <figure className="video">
    <iframe
      loading="lazy"
      src={treatYoutubeUrl(src)}
      title={title}
      allow="autoplay; fullscreen; picture-in-picture"
    />
    {/* {description && <figcaption>{description}</figcaption>} */}
  </figure>
)
